module.exports = __webpack_public_path__ + "static/img/banner-sp.b057ac9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/banner-sp.png
// module id = zOQ0
// module chunks = 0